(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpaca-busqueda"]) return;
  try {
    
  /* Alpaca · colección y búsqueda: orden, filtros y «Ver más» sin recargar. Sin guion, todo funciona con enlaces y formularios.
     El mismo guion vive en alpaca-coleccion; el que llegue primero se arma y el otro no hace nada. */
  (function () {
    if (window.__alpCol) return;
    window.__alpCol = true;
    var lector = new DOMParser();
    var empujado = false;
    var reducido = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function conSeccion(url, id) {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', id);
      return u.toString();
    }
    function traer(url, id) {
      return fetch(conSeccion(url, id), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return lector.parseFromString(t, 'text/html'); });
    }
    function raizDe(el) { return el && el.closest ? el.closest('[data-alp-col]') : null; }

    /* Tras filtrar u ordenar, el control que se tocó desaparece (se reemplaza el cuerpo): se busca su equivalente. */
    function marcaDe(el) {
      if (!el || !el.closest) return null;
      if (el.closest('.alp-col-orden')) return '.alp-col-orden > summary';
      if (el.closest('dialog') || el.matches('[data-alp-abrir]')) return '[data-alp-abrir]';
      if (el.closest('.alp-col-activos')) return '.alp-col-activo';
      return null;
    }
    /* «N diseños» en la región aria-live (fuera del cuerpo, que se reemplaza). */
    function avisar(raiz, nuevo) {
      var zona = raiz.querySelector('[data-alp-col-aviso]');
      if (!zona) return;
      var n = Number(nuevo.getAttribute('data-alp-col-n')) || 0;
      var u = nuevo.getAttribute('data-alp-col-unidad') || 'diseño';
      var txt = n + ' ' + u + (n === 1 ? '' : 's');
      zona.textContent = '';
      setTimeout(function () { zona.textContent = txt; }, 80);
    }

    function reemplazar(raiz, url, empujar, origen) {
      var id = raiz.getAttribute('data-alp-col');
      var cuerpo = raiz.querySelector('[data-alp-col-cuerpo]');
      if (!cuerpo) { location.href = url; return; }
      var volver = !!origen && cuerpo.contains(origen);
      var marca = volver ? marcaDe(origen) : null;
      var abierto = raiz.querySelector('dialog[open]');
      if (abierto) abierto.close();
      cuerpo.setAttribute('aria-busy', 'true');
      traer(url, id).then(function (doc) {
        var nuevo = doc.querySelector('[data-alp-col-cuerpo]');
        if (!nuevo) throw new Error('sin cuerpo');
        cuerpo.replaceWith(nuevo);
        var c1 = raiz.querySelector('[data-alp-col-conteo]'), c2 = doc.querySelector('[data-alp-col-conteo]');
        if (c1 && c2) c1.textContent = c2.textContent;
        if (empujar) { history.pushState({ alpCol: 1 }, '', url); empujado = true; }
        if (window.AlpacaSube) window.AlpacaSube(nuevo);
        avisar(raiz, nuevo);
        if (volver) {
          var destino = (marca && nuevo.querySelector(marca)) || nuevo.querySelector('[data-alp-abrir]') || nuevo.querySelector('.alp-col-orden > summary');
          if (!destino) { destino = raiz.querySelector('h1'); if (destino) destino.setAttribute('tabindex', '-1'); }
          if (destino) destino.focus({ preventScroll: true });
        }
        var barra = nuevo.querySelector('[data-alp-col-barra]') || nuevo;
        if (barra.getBoundingClientRect().top < 0) barra.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      }).catch(function () { location.href = url; });
    }

    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (!f.matches || !f.matches('form[data-alp-col-form]')) return;
      var raiz = raizDe(f);
      if (!raiz || !window.fetch || !window.URLSearchParams) return;
      ev.preventDefault();
      var datos = new FormData(f);
      var p = new URLSearchParams();
      datos.forEach(function (v, k) { if (k !== 'sort_by' && String(v).trim() !== '') p.append(k, v); });
      var s = ev.submitter && ev.submitter.name === 'sort_by' ? ev.submitter.value : datos.get('sort_by');
      if (s) p.set('sort_by', s);
      var base = f.getAttribute('action').split('?')[0];
      var q = p.toString();
      reemplazar(raiz, base + (q ? '?' + q : ''), true, ev.submitter || f);
    });

    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t) return;
      document.querySelectorAll('details.alp-col-orden[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
      var ir = t.closest('[data-alp-col-ir]');
      if (ir) {
        var r1 = raizDe(ir);
        if (r1 && window.fetch) { ev.preventDefault(); reemplazar(r1, ir.href, true, ir); }
        return;
      }
      var mas = t.closest('[data-alp-col-mas]');
      if (!mas || !window.fetch) return;
      var raiz = raizDe(mas);
      if (!raiz) return;
      ev.preventDefault();
      if (mas.getAttribute('aria-busy') === 'true') return;
      var conTeclado = ev.detail === 0;
      mas.setAttribute('aria-busy', 'true');
      traer(mas.href, raiz.getAttribute('data-alp-col')).then(function (doc) {
        var primero = null;
        [['[data-alp-col-grilla]', '[data-alp-col-grilla] > li'], ['[data-alp-col-lista]', '[data-alp-col-lista] > li']].forEach(function (par) {
          var destino = raiz.querySelector(par[0]);
          if (!destino) return;
          doc.querySelectorAll(par[1]).forEach(function (li) { destino.appendChild(li); if (!primero) primero = li; });
        });
        var pag = raiz.querySelector('[data-alp-col-paginas]'), pag2 = doc.querySelector('[data-alp-col-paginas]');
        if (pag) { if (pag2) pag.replaceWith(pag2); else pag.remove(); }
        if (window.AlpacaSube) window.AlpacaSube(raiz);
        if (conTeclado && primero) { var l = primero.querySelector('a'); if (l) l.focus({ preventScroll: false }); }
      }).catch(function () { location.href = mas.href; });
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      document.querySelectorAll('details.alp-col-orden[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
    });

    window.addEventListener('popstate', function () {
      if (!empujado) return;
      var raiz = document.querySelector('[data-alp-col] [data-alp-col-cuerpo]');
      if (raiz) reemplazar(raizDe(raiz), location.href, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-coleccion"]) return;
  try {
    
  /* Alpaca · colección y búsqueda: orden, filtros y «Ver más» sin recargar. Sin guion, todo funciona con enlaces y formularios. */
  (function () {
    if (window.__alpCol) return;
    window.__alpCol = true;
    var lector = new DOMParser();
    var empujado = false;
    var reducido = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function conSeccion(url, id) {
      var u = new URL(url, location.href);
      u.searchParams.set('section_id', id);
      return u.toString();
    }
    function traer(url, id) {
      return fetch(conSeccion(url, id), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) { return lector.parseFromString(t, 'text/html'); });
    }
    function raizDe(el) { return el && el.closest ? el.closest('[data-alp-col]') : null; }

    /* Tras filtrar u ordenar, el control que se tocó desaparece (se reemplaza el cuerpo): se busca su equivalente. */
    function marcaDe(el) {
      if (!el || !el.closest) return null;
      if (el.closest('.alp-col-orden')) return '.alp-col-orden > summary';
      if (el.closest('dialog') || el.matches('[data-alp-abrir]')) return '[data-alp-abrir]';
      if (el.closest('.alp-col-activos')) return '.alp-col-activo';
      return null;
    }
    /* «N diseños» en la región aria-live (fuera del cuerpo, que se reemplaza). */
    function avisar(raiz, nuevo) {
      var zona = raiz.querySelector('[data-alp-col-aviso]');
      if (!zona) return;
      var n = Number(nuevo.getAttribute('data-alp-col-n')) || 0;
      var u = nuevo.getAttribute('data-alp-col-unidad') || 'diseño';
      var txt = n + ' ' + u + (n === 1 ? '' : 's');
      zona.textContent = '';
      setTimeout(function () { zona.textContent = txt; }, 80);
    }

    function reemplazar(raiz, url, empujar, origen) {
      var id = raiz.getAttribute('data-alp-col');
      var cuerpo = raiz.querySelector('[data-alp-col-cuerpo]');
      if (!cuerpo) { location.href = url; return; }
      var volver = !!origen && cuerpo.contains(origen);
      var marca = volver ? marcaDe(origen) : null;
      var abierto = raiz.querySelector('dialog[open]');
      if (abierto) abierto.close();
      cuerpo.setAttribute('aria-busy', 'true');
      traer(url, id).then(function (doc) {
        var nuevo = doc.querySelector('[data-alp-col-cuerpo]');
        if (!nuevo) throw new Error('sin cuerpo');
        cuerpo.replaceWith(nuevo);
        var c1 = raiz.querySelector('[data-alp-col-conteo]'), c2 = doc.querySelector('[data-alp-col-conteo]');
        if (c1 && c2) c1.textContent = c2.textContent;
        if (empujar) { history.pushState({ alpCol: 1 }, '', url); empujado = true; }
        if (window.AlpacaSube) window.AlpacaSube(nuevo);
        avisar(raiz, nuevo);
        if (volver) {
          var destino = (marca && nuevo.querySelector(marca)) || nuevo.querySelector('[data-alp-abrir]') || nuevo.querySelector('.alp-col-orden > summary');
          if (!destino) { destino = raiz.querySelector('h1'); if (destino) destino.setAttribute('tabindex', '-1'); }
          if (destino) destino.focus({ preventScroll: true });
        }
        var barra = nuevo.querySelector('[data-alp-col-barra]') || nuevo;
        if (barra.getBoundingClientRect().top < 0) barra.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'start' });
      }).catch(function () { location.href = url; });
    }

    document.addEventListener('submit', function (ev) {
      var f = ev.target;
      if (!f.matches || !f.matches('form[data-alp-col-form]')) return;
      var raiz = raizDe(f);
      if (!raiz || !window.fetch || !window.URLSearchParams) return;
      ev.preventDefault();
      var datos = new FormData(f);
      var p = new URLSearchParams();
      datos.forEach(function (v, k) { if (k !== 'sort_by' && String(v).trim() !== '') p.append(k, v); });
      var s = ev.submitter && ev.submitter.name === 'sort_by' ? ev.submitter.value : datos.get('sort_by');
      if (s) p.set('sort_by', s);
      var base = f.getAttribute('action').split('?')[0];
      var q = p.toString();
      reemplazar(raiz, base + (q ? '?' + q : ''), true, ev.submitter || f);
    });

    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t) return;
      document.querySelectorAll('details.alp-col-orden[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
      var ir = t.closest('[data-alp-col-ir]');
      if (ir) {
        var r1 = raizDe(ir);
        if (r1 && window.fetch) { ev.preventDefault(); reemplazar(r1, ir.href, true, ir); }
        return;
      }
      var mas = t.closest('[data-alp-col-mas]');
      if (!mas || !window.fetch) return;
      var raiz = raizDe(mas);
      if (!raiz) return;
      ev.preventDefault();
      if (mas.getAttribute('aria-busy') === 'true') return;
      var conTeclado = ev.detail === 0;
      mas.setAttribute('aria-busy', 'true');
      traer(mas.href, raiz.getAttribute('data-alp-col')).then(function (doc) {
        var primero = null;
        [['[data-alp-col-grilla]', '[data-alp-col-grilla] > li'], ['[data-alp-col-lista]', '[data-alp-col-lista] > li']].forEach(function (par) {
          var destino = raiz.querySelector(par[0]);
          if (!destino) return;
          doc.querySelectorAll(par[1]).forEach(function (li) { destino.appendChild(li); if (!primero) primero = li; });
        });
        var pag = raiz.querySelector('[data-alp-col-paginas]'), pag2 = doc.querySelector('[data-alp-col-paginas]');
        if (pag) { if (pag2) pag.replaceWith(pag2); else pag.remove(); }
        if (window.AlpacaSube) window.AlpacaSube(raiz);
        if (conTeclado && primero) { var l = primero.querySelector('a'); if (l) l.focus({ preventScroll: false }); }
      }).catch(function () { location.href = mas.href; });
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape') return;
      document.querySelectorAll('details.alp-col-orden[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
    });

    window.addEventListener('popstate', function () {
      if (!empujado) return;
      var raiz = document.querySelector('[data-alp-col] [data-alp-col-cuerpo]');
      if (raiz) reemplazar(raizDe(raiz), location.href, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-ficha-historia"] && !Shopify.designMode) return;
  try {
    
  /* Alpaca · «Del telar a tu puerta»: escenario dibujado en SVG que avanza con el desplazamiento.
     Un solo listener de scroll pasivo que pide un cuadro (requestAnimationFrame); IntersectionObserver para cargar la foto.
     El dibujo está en coordenadas 400 × 440. */
  (function () {
    var NS = 'http://www.w3.org/2000/svg', XL = 'http://www.w3.org/1999/xlink';
    /* Peso de cada paso (cuánto se baja en cada uno) y dónde termina cada dibujo en la versión quieta. */
    var PESOS = [1, 1.7, 1.5, 1.7, 1.5, 1.1], FINES = [1, 1, 0.95, 1, 1, 1];
    var SUMA = 0, INI = [], q;
    for (q = 0; q < PESOS.length; q++) { INI.push(SUMA); SUMA += PESOS[q]; }
    /* El contorno del Ecuador es el de la página de envíos (viewBox 25 0 825 660), escalado al escenario. */
    var MAPA = { x: -135.5, y: 20.5, s: 0.61 };
    function en(x, y) { return [x * MAPA.s + MAPA.x, y * MAPA.s + MAPA.y]; }
    var PEGUCHE = en(536.4, 125.2), QUITO = en(508.8, 172);
    var CORD = 'M0 60V44C40 40 90 30 150 20C175 16 190 24 230 36C265 46 300 30 345 12C365 4 395 4 415 12C450 26 470 38 505 36C540 34 560 22 590 18C620 14 660 32 720 40V60Z';

    function cl(v, a, b) { return v < a ? a : v > b ? b : v; }
    function tr(t, a, b) { return cl((t - a) / (b - a), 0, 1); }
    function io(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function eo(t) { return 1 - Math.pow(1 - t, 3); }
    function mz(a, b, t) { return a + (b - a) * t; }
    function r1(n) { return Math.round(n * 10) / 10; }
    function r3(n) { return Math.round(n * 1000) / 1000; }
    function nz(s) { return Math.abs(s) < 0.02 ? (s < 0 ? -0.02 : 0.02) : s; }
    function limpio(t) { return String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z]+/g, ' ').trim(); }

    /* Las clases de color también van como atributo: los <use> clonan el dibujo
       en un árbol aparte donde los selectores «.alp-hf .h-x» no llegan. */
    var PINTA = {
      'h-n': { fill: '#0c1d3a' }, 'h-m': { fill: '#e3a72f' }, 'h-s': { fill: '#e4edee' },
      'h-a': { fill: '#f2daaa' }, 'h-b': { fill: '#d6e3e6' }, 'h-p': { fill: '#b4b9c2' },
      'h-z': { fill: '#546074' }, 'h-w': { fill: '#ffffff' },
      'h-tr': { fill: 'none', stroke: '#0c1d3a', 'stroke-linecap': 'round', 'stroke-linejoin': 'round' },
      'h-fina': { 'stroke-opacity': '0.3' },
      'h-mano': { fill: '#0c1d3a', 'font-weight': '600', 'font-family': 'Caveat, cursive' }
    };
    function N(tag, at, padre) {
      var e = document.createElementNS(NS, tag);
      if (at && at['class']) String(at['class']).split(' ').forEach(function (c) {
        var p = PINTA[c]; if (p) for (var q in p) if (!(q in at)) e.setAttribute(q, p[q]);
      });
      if (at) for (var k in at) e.setAttribute(k, at[k]);
      if (padre) padre.appendChild(e);
      return e;
    }
    /* Escribe un atributo solo si cambió (cada cuadro toca lo mínimo). */
    function A(e, k, v) { v = String(v); if (e['_a' + k] !== v) { e['_a' + k] = v; e.setAttribute(k, v); } }
    function O(e, o) { o = o < 0.002 ? 0 : o > 0.998 ? 1 : r3(o); A(e, 'opacity', o); A(e, 'visibility', o ? 'visible' : 'hidden'); }
    function usar(padre, id) { var u = N('use', null, padre); u.setAttribute('href', '#' + id); u.setAttributeNS(XL, 'xlink:href', '#' + id); return u; }

    /* ── Formas: 16 puntos [x, y, radio] en el mismo orden, para pasar de una a otra ── */
    function rectP(x0, y0, x1, y1, r) {
      var w = x1 - x0, h = y1 - y0, P = [], i;
      for (i = 0; i < 5; i++) P.push([x0 + w * i / 4, y0, i === 0 || i === 4 ? r : 0]);
      for (i = 1; i < 4; i++) P.push([x1, y0 + h * i / 4, 0]);
      P.push([x1, y1, r]);
      for (i = 3; i >= 0; i--) P.push([x0 + w * i / 4, y1, i === 0 ? r : 0]);
      for (i = 3; i >= 1; i--) P.push([x0, y0 + h * i / 4, 0]);
      return P;
    }
    /* Arco de puerta (la foto entra en él): medio círculo arriba, recto abajo. */
    function arco() {
      var P = [], cy = 152, i;
      for (i = 0; i < 5; i++) { var a = Math.PI - i * Math.PI / 4; P.push([200 + 110 * Math.cos(a), cy - 110 * Math.sin(a), i === 0 || i === 4 ? 0 : 60]); }
      for (i = 1; i < 4; i++) P.push([310, cy + (402 - cy) * i / 4, 0]);
      P.push([310, 402, 16]);
      for (i = 3; i >= 0; i--) P.push([90 + 55 * i, 402, i === 0 ? 16 : 0]);
      for (i = 3; i >= 1; i--) P.push([90, cy + (402 - cy) * i / 4, 0]);
      return P;
    }
    var SILUETAS = {
      poncho: [[146, 100, 16], [174, 84, 6], [200, 100, 3], [226, 84, 6], [254, 100, 16], [306, 122, 40], [342, 186, 50], [358, 270, 24], [354, 352, 6], [280, 358, 0], [200, 362, 0], [120, 358, 0], [46, 352, 6], [42, 270, 24], [58, 186, 50], [94, 122, 40]],
      chal: [[138, 66, 4], [168, 62, 0], [200, 68, 0], [232, 62, 0], [262, 66, 4], [266, 148, 0], [270, 232, 0], [266, 314, 0], [268, 374, 3], [236, 378, 0], [202, 372, 0], [168, 378, 0], [134, 374, 3], [130, 314, 0], [134, 232, 0], [130, 148, 0]],
      cobija: [[40, 126, 6], [120, 122, 0], [200, 126, 0], [280, 122, 0], [360, 126, 6], [362, 176, 0], [360, 226, 0], [362, 276, 0], [360, 322, 6], [280, 326, 0], [200, 322, 0], [120, 326, 0], [40, 322, 6], [38, 276, 0], [40, 226, 0], [38, 176, 0]]
    };
    /* Flecos: por qué borde caen y hacia dónde. */
    var FLECOS = {
      poncho: [[[8, 9, 10, 11, 12], [0, 1]]],
      chal: [[[8, 9, 10, 11, 12], [0, 1]], [[0, 1, 2, 3, 4], [0, -1]]],
      cobija: [[[12, 13, 14, 15, 0], [-1, 0]], [[4, 5, 6, 7, 8], [1, 0]]]
    };
    function flecosD(P, spec) {
      var d = '';
      spec.forEach(function (sp) {
        var idx = sp[0], dir = sp[1], resto = 4;
        for (var i = 0; i < idx.length - 1; i++) {
          var a = P[idx[i]], b = P[idx[i + 1]], L = Math.hypot(b[0] - a[0], b[1] - a[1]);
          while (resto < L) {
            var f = resto / L;
            d += 'M' + r1(a[0] + (b[0] - a[0]) * f - dir[0]) + ' ' + r1(a[1] + (b[1] - a[1]) * f - dir[1]) + 'l' + dir[0] * 13 + ' ' + dir[1] * 13;
            resto += 7;
          }
          resto -= L;
        }
      });
      return d;
    }
    function camino(P) {
      var n = P.length, d = '';
      for (var i = 0; i < n; i++) {
        var a = P[(i + n - 1) % n], b = P[i], c = P[(i + 1) % n];
        var l1 = Math.hypot(a[0] - b[0], a[1] - b[1]), l2 = Math.hypot(c[0] - b[0], c[1] - b[1]);
        var r = Math.min(b[2], l1 / 2, l2 / 2), m = i ? 'L' : 'M';
        if (r < 0.4 || l1 < 0.01 || l2 < 0.01) { d += m + r1(b[0]) + ' ' + r1(b[1]); continue; }
        d += m + r1(b[0] + (a[0] - b[0]) * r / l1) + ' ' + r1(b[1] + (a[1] - b[1]) * r / l1) +
          'Q' + r1(b[0]) + ' ' + r1(b[1]) + ' ' + r1(b[0] + (c[0] - b[0]) * r / l2) + ' ' + r1(b[1] + (c[1] - b[1]) * r / l2);
      }
      return d + 'Z';
    }
    function mezcla(P, Q, t) {
      if (t <= 0) return P;
      if (t >= 1) return Q;
      return P.map(function (a, i) { var b = Q[i]; return [mz(a[0], b[0], t), mz(a[1], b[1], t), mz(a[2], b[2], t)]; });
    }
    /* Los rombos del poncho (la misma idea que snippets/alpaca-telar): rombos concéntricos sobre azul marino,
       arena y celeste, y una franja celeste entre motivo y motivo. Celdas de 10 × 10.
       (La mostaza queda solo para acentos chicos: la canilla, los puntos, la etiqueta y la línea de la ruta.) */
    function color(c, r) {
      var rr = r % 14, cc = c % 12;
      if (rr === 13) return 's';
      var d = Math.abs(cc - 5.5) + Math.abs(rr - 6);
      if (d === 0.5 || d === 4.5) return 'm';
      if (d === 2.5 || d === 11.5) return 's';
      return 'n';
    }

    function Escena(lienzo, D, pref) {
      var tipo = SILUETAS[D.tipo] ? D.tipo : 'poncho';
      var SIL = SILUETAS[tipo], RECT = rectP(80, 80, 320, 360, 6), ARCO = arco(), R1 = rectP(100, 100, 300, 340, 6), MITAD = rectP(100, 220, 300, 340, 6);
      var svg = N('svg', { viewBox: '0 0 400 440', class: 'alp-hf__svg', 'aria-hidden': 'true', focusable: 'false' });
      var defs = N('defs', null, svg);
      function url(n) { return 'url(#' + pref + n + ')'; }
      function clip(n, at, tag) { var cp = N('clipPath', { id: pref + n }, defs); return N(tag || 'rect', at, cp); }
      function texto(padre, t, x, y, ancla, tam, clase) {
        var e = N('text', { class: 'h-mano' + (clase ? ' ' + clase : ''), x: r1(x), y: r1(y), 'text-anchor': ancla, 'font-size': tam }, padre);
        e.textContent = t;
        return e;
      }

      /* 1. La puerta (último paso), al fondo */
      var puerta = N('g', null, svg);
      N('path', { class: 'h-s', d: CORD, transform: 'translate(0 312) scale(0.5556 1.2)' }, puerta);
      N('path', { class: 'h-b', d: 'M128 384V208a58 58 0 0 1 116 0V384Z' }, puerta);
      N('path', { class: 'h-tr h-fina', d: 'M142 384V212a44 44 0 0 1 88 0V384', 'stroke-width': 1.4 }, puerta);
      N('path', { class: 'h-tr', d: 'M128 384V208a58 58 0 0 1 116 0V384M20 384H380', 'stroke-width': 2 }, puerta);
      N('circle', { class: 'h-n', cx: 222, cy: 296, r: 4 }, puerta);
      N('rect', { class: 'h-a', x: 136, y: 378, width: 100, height: 6, rx: 3 }, puerta);
      texto(puerta, 'tu puerta', 262, 168, 'start', 24);
      N('path', { class: 'h-tr', d: 'M282 178c-4 18-16 30-32 36M249 204l1 11 10-4', 'stroke-width': 1.6 }, puerta);

      /* 2. El mapa */
      var mapa = N('g', null, svg), zoom = N('g', null, mapa);
      var base = N('g', { transform: 'translate(' + MAPA.x + ' ' + MAPA.y + ') scale(' + MAPA.s + ')' }, zoom);
      if (D.tierra) N('path', { class: 'alp-hf__tierra', d: D.tierra }, base);
      /* Solo el continente: Galápagos queda fuera del cuadro (su texto lo explica). */
      clip('isla', { x: 250, y: -60, width: 700, height: 800 });
      base.setAttribute('clip-path', url('isla'));
      var lugares = N('g', { class: 'alp-hf__lugares' }, base);
      (D.lugares || []).forEach(function (l) { if (l && l.x > 255) N('circle', { cx: l.x, cy: l.y, r: 3.2 }, lugares); });
      var rutaG = N('g', null, zoom);
      var origen = N('g', null, zoom);
      N('circle', { class: 'h-w alp-hf__quito', cx: r1(QUITO[0]), cy: r1(QUITO[1]), r: 4 }, origen);
      N('circle', { class: 'h-m alp-hf__peguche', cx: r1(PEGUCHE[0]), cy: r1(PEGUCHE[1]), r: 4.6 }, origen);
      texto(origen, 'se teje en Peguche', PEGUCHE[0] + 13, PEGUCHE[1] - 6, 'start', 19, 'alp-hf__mapa-rot');
      texto(origen, 'sale de Quito', QUITO[0] - 9, QUITO[1] + 6, 'end', 19, 'alp-hf__mapa-rot');
      var ciudadG = N('g', null, zoom);

      /* 3. El telar: postes, urdimbre, travesaños, batán y la barra de la composición */
      var telar = N('g', null, svg);
      N('path', { class: 'h-tr', d: 'M60 36V390M340 36V390', 'stroke-width': 3 }, telar);
      var hilos = [];
      for (var i = 0; i < 25; i++) hilos.push(N('path', { class: 'h-tr', 'stroke-width': 1.3, 'stroke-opacity': 0.85 }, telar));
      N('rect', { class: 'h-n', x: 54, y: 44, width: 292, height: 11, rx: 5.5 }, telar);
      N('rect', { class: 'h-n', x: 54, y: 364, width: 292, height: 11, rx: 5.5 }, telar);
      var batan = N('rect', { class: 'h-z', x: 66, y: 0, width: 268, height: 5, rx: 2.5 }, telar);
      var comp = N('g', null, telar), compBarra = N('g', null, comp);
      var w1 = D.c1 > 0 ? 240 * D.c1 / (D.c1 + D.c2) : 240;
      if (D.c1 > 0 && D.c2 > 0) N('rect', { class: 'h-n', x: 80, y: 396, width: r1(w1 - 2), height: 8, rx: 4 }, compBarra);
      if (D.c1 > 0 && D.c2 > 0) N('rect', { class: 'h-p', x: r1(80 + w1 + 2), y: 396, width: r1(240 - w1 - 2), height: 8, rx: 4 }, compBarra);
      var compT = N('g', null, comp);
      if (!(D.c1 > 0) && D.txt) texto(compT, D.txt, 80, 428, 'start', 16);
      if (D.c1 > 0) texto(compT, D.c1 + ' % ' + D.n1, 80, 428, 'start', 18);
      if (D.c2 > 0) texto(compT, D.c2 + ' % ' + D.n2, 320, 428, 'end', 18);

      /* 4. La caja por detrás (la pared del fondo se ve sobre el borde) */
      var cajaA = N('g', null, svg);
      N('rect', { class: 'h-z', x: -60, y: -50, width: 120, height: 14, rx: 3 }, cajaA);

      /* 5. El tejido: 28 filas, cada una se descubre con su propio recorte, de abajo hacia arriba */
      var tela = N('g', { id: pref + 'tela' }, defs);
      var filas = [];
      for (var r = 0; r < 28; r++) {
        var y = 80 + r * 10, k = 27 - r;
        var rc = clip('f' + r, { x: 80, y: y - 0.4, width: 0, height: 10.8 });
        var g = N('g', { 'clip-path': url('f' + r) }, tela);
        N('rect', { class: 'h-n', x: 80, y: y - 0.4, width: 240, height: 10.8 }, g);
        var dm = '', ds = '', c = 0;
        while (c < 24) {
          var col = color(c, r), c2 = c;
          while (c2 < 23 && color(c2 + 1, r) === col) c2++;
          var n = (c2 - c + 1) * 10, tramo = 'M' + (80 + c * 10) + ' ' + (y - 0.4) + 'h' + n + 'v10.8h-' + n + 'z';
          if (col === 'm') dm += tramo; else if (col === 's') ds += tramo;
          c = c2 + 1;
        }
        if (dm) N('path', { class: 'h-a', d: dm }, g);
        if (ds) N('path', { class: 'h-s', d: ds }, g);
        filas.push({ rc: rc, k: k, izq: k % 2 === 0, w: 0 });
      }
      /* La prenda: el tejido recortado por la forma que cambia, y la foto real encima. Más la primera solapa (doblez). */
      var d1 = N('g', { id: pref + 'd1' }, defs);
      var forma = clip('forma', { d: camino(RECT) }, 'path');
      var prenda = N('g', { 'clip-path': url('forma') }, d1);
      usar(prenda, pref + 'tela');
      /* La foto entra por encima del tejido a opacidad plena, descubierta por un círculo que crece
         (y al volver a tejido, el círculo se cierra): nunca se mezclan semitransparentes. */
      var revela = clip('revela', { cx: 200, cy: 236, r: 0 }, 'circle');
      var fotoG = N('g', { 'clip-path': url('revela') }, prenda);
      N('rect', { class: 'h-s', x: 60, y: 20, width: 280, height: 400 }, fotoG);
      var foto = N('image', { x: 90, y: 42, width: 220, height: 360, preserveAspectRatio: 'xMidYMid slice' }, fotoG);
      var solapa1 = N('g', null, d1), s1in = N('g', { 'clip-path': url('arriba') }, solapa1);
      clip('arriba', { x: 100, y: 100, width: 200, height: 120 });
      usar(s1in, pref + 'tela');
      /* La solapa que se dobla lleva la misma foto que la prenda (paso 4 coherente con el 3): no vuelve a rombos. */
      var fotoS = N('g', null, s1in);
      N('rect', { class: 'h-s', x: 60, y: 20, width: 280, height: 400 }, fotoS);
      var foto2 = N('image', { x: 90, y: 42, width: 220, height: 360, preserveAspectRatio: 'xMidYMid slice' }, fotoS);
      O(fotoS, D.foto ? 1 : 0);
      var sombra1 = N('rect', { class: 'h-n', x: 100, y: 100, width: 200, height: 120 }, s1in);

      var piso = N('g', null, svg);
      clip('piso', { x: -400, y: -400, width: 1200, height: 792 });
      var pieza = N('g', null, piso);
      var izq = N('g', { 'clip-path': url('izq') }, pieza);
      var cIzq = clip('izq', { x: -400, y: -400, width: 1200, height: 1200 });
      usar(izq, pref + 'd1');
      var solapa2 = N('g', null, pieza), s2in = N('g', { 'clip-path': url('der') }, solapa2);
      clip('der', { x: 200, y: 220, width: 100, height: 120 });
      usar(s2in, pref + 'd1');
      var sombra2 = N('rect', { class: 'h-n', x: 200, y: 220, width: 100, height: 120 }, s2in);
      var flecos = N('path', { class: 'h-tr', d: flecosD(SIL, FLECOS[tipo]), 'stroke-width': 1.7 }, pieza);
      var anillo = N('path', { class: 'h-tr alp-hf__anillo', d: camino(ARCO), transform: 'translate(200 222) scale(1.05) translate(-200 -222)' }, pieza);

      /* La tarjeta con el mensaje */
      var tarjeta = N('g', null, piso);
      N('rect', { class: 'h-w alp-hf__papel', x: -36, y: -24, width: 72, height: 48, rx: 2 }, tarjeta);
      var tLineas = N('path', { class: 'h-tr h-fina', d: 'M-26 -8H26M-26 2H20M-26 12H10', 'stroke-width': 1.5 }, tarjeta);
      var tT1 = texto(tarjeta, '', -28, -3, 'start', 10), tT2 = texto(tarjeta, '', -28, 10, 'start', 10);

      /* 6. La caja por delante, con su cinta, la cordillera y la tapa con el lazo y el hilo de la etiqueta */
      var cajaB = N('g', null, svg);
      N('rect', { class: 'h-n', x: -60, y: -40, width: 120, height: 80, rx: 5 }, cajaB);
      N('path', { class: 'h-z', d: CORD, transform: 'translate(-60 26) scale(0.16667 0.2)' }, cajaB);
      N('rect', { class: 'h-a', x: -6, y: -40, width: 12, height: 80 }, cajaB);
      var tapa = N('g', null, cajaB);
      N('rect', { class: 'h-n', x: -65, y: -53, width: 130, height: 17, rx: 4 }, tapa);
      N('rect', { class: 'h-a', x: -6, y: -53, width: 12, height: 17 }, tapa);
      var hiloTag = N('path', { class: 'h-tr', d: 'M2 -53C30 -72 74 -62 80 -26', 'stroke-width': 1.2, pathLength: 1, 'stroke-dasharray': 1, 'stroke-dashoffset': 1 }, tapa);
      N('path', { class: 'h-a alp-hf__lazo', d: 'M0 -53C-6 -66 -26 -68 -24 -58C-23 -52 -10 -51 0 -53ZM0 -53C6 -66 26 -68 24 -58C23 -52 10 -51 0 -53Z' }, tapa);
      N('circle', { class: 'h-a alp-hf__lazo', cx: 0, cy: -53, r: 3.6 }, tapa);

      /* 7. La lanzadera */
      var lanz = N('g', null, svg);
      N('path', { class: 'h-a alp-hf__lanz', d: 'M-26 0C-16 -7.5 -7 -8 0 -8S16 -7.5 26 0C16 7.5 7 8 0 8S-16 7.5 -26 0Z' }, lanz);
      N('rect', { class: 'h-m', x: -9, y: -2.6, width: 18, height: 5.2, rx: 2.6 }, lanz);

      /* La etiqueta colgada (pieza global .alp-tag), por encima del dibujo */
      var tag = document.createElement('span');
      tag.className = 'alp-tag alp-hf__tag';
      tag.setAttribute('aria-hidden', 'true');
      var tagTxt = document.createElement('span');
      tagTxt.className = 'alp-mano';
      tagTxt.textContent = 'Para: ti';
      tag.appendChild(tagTxt);
      lienzo.appendChild(svg);
      lienzo.appendChild(tag);

      /* ── La ruta: de Peguche a Quito y de Quito a la ciudad, en puntos mostaza ── */
      var R = { M: [], L: [0], total: 1, puntos: [], fin: QUITO, pulso: null };
      function curva(a, b, kk, M) {
        var dx = b[0] - a[0], dy = b[1] - a[1], cx = (a[0] + b[0]) / 2 - dy * kk, cy = (a[1] + b[1]) / 2 + dx * kk;
        for (var j = M.length ? 1 : 0; j <= 32; j++) {
          var t = j / 32, u = 1 - t;
          M.push([u * u * a[0] + 2 * u * t * cx + t * t * b[0], u * u * a[1] + 2 * u * t * cy + t * t * b[1]]);
        }
      }
      function enRuta(f) {
        var s = f * R.total, L = R.L, j = 1;
        while (j < L.length - 1 && L[j] < s) j++;
        var a = R.M[j - 1], b = R.M[j] || a, largo = (L[j] - L[j - 1]) || 1, u = cl((s - L[j - 1]) / largo, 0, 1);
        return [a[0] + (b[0] - a[0]) * u, a[1] + (b[1] - a[1]) * u];
      }
      function ruta(dest, nombre, ejemplo) {
        while (rutaG.firstChild) rutaG.removeChild(rutaG.firstChild);
        while (ciudadG.firstChild) ciudadG.removeChild(ciudadG.firstChild);
        R.M = [];
        curva(PEGUCHE, QUITO, 0.3, R.M);
        R.fin = QUITO;
        if (dest && Math.hypot(dest[0] - QUITO[0], dest[1] - QUITO[1]) > 5) { curva(QUITO, dest, 0.22, R.M); R.fin = dest; }
        R.L = [0];
        for (var j = 1; j < R.M.length; j++) R.L.push(R.L[j - 1] + Math.hypot(R.M[j][0] - R.M[j - 1][0], R.M[j][1] - R.M[j - 1][1]));
        R.total = R.L[R.L.length - 1] || 1;
        R.puntos = [];
        for (var s = 3; s < R.total - 2; s += 6.5) {
          var pt = enRuta(s / R.total);
          R.puntos.push({ el: N('circle', { class: 'h-m', cx: r1(pt[0]), cy: r1(pt[1]), r: 2.1, opacity: 0 }, rutaG), f: s / R.total });
        }
        R.pulso = null;
        if (dest && nombre) {
          var x = R.fin[0], y = R.fin[1], der = x > 290;
          R.pulso = N('circle', { class: 'alp-hf__pulso', cx: r1(x), cy: r1(y), r: 5.5 }, ciudadG);
          N('circle', { class: 'h-n alp-hf__punto', cx: r1(x), cy: r1(y), r: 5.5 }, ciudadG);
          var dy = R.fin === QUITO ? 22 : 6;
          texto(ciudadG, nombre, der ? x - 11 : x + 11, y + dy, der ? 'end' : 'start', 22, 'alp-hf__mapa-rot');
          if (ejemplo) texto(ciudadG, '(ejemplo)', der ? x - 11 : x + 11, y + dy + 18, der ? 'end' : 'start', 16, 'alp-hf__mapa-rot');
        }
        ultimo = -1;
      }

      function mensaje(t) {
        t = String(t || '').replace(/\s+/g, ' ').trim();
        if (!t) { O(tLineas, 1); tT1.textContent = ''; tT2.textContent = ''; return; }
        O(tLineas, 0);
        var l1 = '', l2 = '';
        t.split(' ').forEach(function (w) {
          if (!l2 && (l1 + ' ' + w).trim().length <= 13) l1 = (l1 + ' ' + w).trim();
          else l2 = (l2 + ' ' + w).trim();
        });
        if (l1.length > 13) l1 = l1.slice(0, 12) + '…';
        if (l2.length > 13) l2 = l2.slice(0, 12).trim() + '…';
        tT1.textContent = l1;
        tT2.textContent = l2;
      }

      var cargada = false;
      function cargarFoto() {
        if (cargada || !D.foto) return;
        cargada = true;
        var u = /^\/\//.test(D.foto) ? 'https:' + D.foto : D.foto;
        [foto, foto2].forEach(function (im) {
          im.setAttribute('href', u);
          im.setAttributeNS(XL, 'xlink:href', u);
        });
      }

      /* La etiqueta se mece con la velocidad del desplazamiento (un resorte amortiguado). */
      var th = 0, om = 0;
      function mecer(vel, dt) {
        var acc = -40 * th - 3.2 * om - 600 * vel;
        om += acc * dt;
        th += om * dt;
        if (th > 28) { th = 28; om = 0; }
        if (th < -28) { th = -28; om = 0; }
        var sigue = Math.abs(th) > 0.05 || Math.abs(om) > 0.3;
        if (!sigue) { th = 0; om = 0; }
        return sigue;
      }

      var ultimo = -1, ultimoSag = -1, tagCss = '';
      function pintar(p) {
        var T = [];
        for (var j = 0; j < 6; j++) T.push(cl((p * SUMA - INI[j]) / PESOS[j], 0, 1));
        var t0 = T[0], t1 = T[1], t2 = T[2], t3 = T[3], t4 = T[4], t5 = T[5];

        /* Paso 1 · los hilos se tensan y se llena la composición */
        var fueraTelar = tr(t2, 0, 0.16);
        O(telar, 1 - fueraTelar);
        if (fueraTelar < 1) {
          var sag = r1(26 * (1 - io(tr(t0, 0.04, 0.7))));
          if (sag !== ultimoSag) {
            ultimoSag = sag;
            hilos.forEach(function (h, i2) {
              var x = 80 + i2 * 10, s = sag * (0.6 + 0.4 * Math.sin(i2 * 1.7));
              A(h, 'd', 'M' + x + ' 55Q' + r1(x + s) + ' 210 ' + x + ' 365');
            });
          }
          A(compBarra, 'transform', 'translate(80 0) scale(' + Math.max(r3(eo(tr(t0, 0.2, 0.8))), 0.001) + ' 1) translate(-80 0)');
          O(compT, tr(t0, 0.45, 0.75));
          O(comp, 1 - tr(t1, 0, 0.12));
        }

        /* Paso 2 · la lanzadera teje fila por fila */
        var rr = tr(t1, 0.02, 0.92) * 28;
        for (var f = 0; f < 28; f++) {
          var fl = filas[f], w = r1(240 * cl(rr - fl.k, 0, 1));
          if (fl.w !== w) { fl.w = w; A(fl.rc, 'width', w); if (!fl.izq) A(fl.rc, 'x', r1(320 - w)); }
        }
        var ka = Math.min(27, Math.floor(rr)), fa = rr - ka, xL, yL, oL;
        if (t1 <= 0.02) { xL = mz(-40, 96, eo(tr(t0, 0.6, 1))); yL = 355; oL = tr(t0, 0.6, 0.8); }
        else if (rr < 28) { xL = ka % 2 === 0 ? 96 + 240 * fa : 304 - 240 * fa; yL = 80 + (27 - ka) * 10 + 5; oL = 1; }
        else { xL = 64 - 110 * tr(t1, 0.92, 1); yL = 85; oL = 1 - tr(t1, 0.94, 1); }
        A(lanz, 'transform', 'translate(' + r1(xL) + ' ' + r1(yL) + ')');
        O(lanz, oL * (1 - tr(t2, 0, 0.05)));
        A(batan, 'y', r1(352 - rr * 10));
        O(batan, tr(t1, 0, 0.05) * (1 - tr(t1, 0.9, 0.97)));

        /* Paso 3 · el tejido crece, toma la silueta, y se vuelve la foto real en un arco */
        var crece = io(tr(t2, 0.05, 0.55));
        A(tela, 'transform', crece ? 'translate(200 220) scale(' + r3(1 + 0.35 * crece) + ') translate(-200 -220)' : '');
        var fm;
        if (t3 <= 0) fm = mezcla(mezcla(RECT, SIL, crece), ARCO, io(tr(t2, 0.62, 0.92)));
        else fm = t3 >= 0.18 ? MITAD : mezcla(ARCO, R1, io(tr(t3, 0, 0.16)));
        A(forma, 'd', camino(fm));
        /* La foto queda puesta también al doblarse (paso 4); solo el anillo de la puerta se va. */
        var fo = tr(t2, 0.66, 0.9);
        O(fotoG, D.foto && fo > 0 ? 1 : 0);
        A(revela, 'r', r1(232 * io(fo)));
        O(anillo, fo * (1 - tr(t3, 0, 0.14)));
        var fq = tr(t2, 0.42, 0.56) * (1 - tr(t2, 0.6, 0.7));
        O(flecos, fq);
        A(flecos, 'transform', 'translate(0 ' + r1(-5 * (1 - fq)) + ')');

        /* Paso 4 · dos dobleces, a la caja, la tarjeta, la tapa y la etiqueta */
        var dob1 = io(tr(t3, 0.18, 0.36)), dob2 = io(tr(t3, 0.38, 0.54));
        O(solapa1, t3 >= 0.18 ? 1 : 0);
        var s1 = 1 - 2 * dob1;
        A(solapa1, 'transform', 'translate(0 220) scale(1 ' + r3(nz(s1)) + ') translate(0 -220)');
        O(sombra1, 0.25 * (1 - Math.abs(s1)));
        var dobla2 = t3 >= 0.38;
        A(cIzq, 'x', dobla2 ? -100 : -400);
        A(cIzq, 'width', dobla2 ? 300 : 1200);
        O(solapa2, dobla2 ? 1 : 0);
        var s2 = 1 - 2 * dob2;
        A(solapa2, 'transform', 'translate(200 0) scale(' + r3(nz(s2)) + ' 1) translate(-200 0)');
        O(sombra2, 0.25 * (1 - Math.abs(s2)));
        var baja = io(tr(t3, 0.56, 0.74));
        A(pieza, 'transform', baja ? 'translate(' + r1(107 * baja) + ' ' + r1(166.4 * baja) + ') scale(' + r3(1 - 0.38 * baja) + ')' : '');
        A(piso, 'clip-path', t3 >= 0.5 ? url('piso') : 'none');
        var dentro = 1 - tr(t4, 0, 0.03);
        O(pieza, dentro);
        var tc = io(tr(t3, 0.64, 0.8));
        O(tarjeta, tr(t3, 0.6, 0.66) * (1 - tr(t3, 0.9, 0.94)) * dentro);
        A(tarjeta, 'transform', 'translate(' + r1(mz(322, 222, tc)) + ' ' + r1(mz(196, 322, tc)) + ') rotate(' + r1(mz(16, 7, tc)) + ')');

        var ax, ay, sc, oc;
        if (t5 > 0) {
          var e5 = io(tr(t5, 0.08, 0.5));
          ax = mz(R.fin[0], 96, e5); ay = mz(R.fin[1], 384, e5); sc = mz(0.17, 0.8, e5); oc = 1;
        } else if (t4 > 0) {
          var k1 = io(tr(t4, 0, 0.22)), pt = enRuta(io(tr(t4, 0.24, 0.86)));
          ax = mz(200, pt[0], k1); ay = mz(392, pt[1], k1); sc = mz(1, 0.17, k1); oc = 1;
        } else {
          var ap = eo(tr(t3, 0.4, 0.56));
          ax = 200; ay = 392 + 90 * (1 - ap); sc = 1; oc = ap;
        }
        var tcaja = 'translate(' + r1(ax) + ' ' + r1(ay) + ') scale(' + r3(sc) + ') translate(0 -40)';
        A(cajaA, 'transform', tcaja); A(cajaB, 'transform', tcaja);
        O(cajaA, oc); O(cajaB, oc);
        var cierra = (t4 > 0 || t5 > 0) ? 1 : io(tr(t3, 0.76, 0.92));
        A(tapa, 'transform', cierra >= 1 ? '' : 'translate(' + r1(120 * (1 - cierra)) + ' ' + r1(-44 * (1 - cierra)) + ') rotate(' + r1(16 * (1 - cierra)) + ')');
        A(hiloTag, 'stroke-dashoffset', (t4 > 0 || t5 > 0) ? 0 : r3(1 - tr(t3, 0.9, 0.98)));

        var tagO = t5 > 0 ? tr(t5, 0.42, 0.56) : t4 > 0 ? 1 - tr(t4, 0, 0.1) : tr(t3, 0.93, 1);
        var css = r1((ax + 80 * sc) / 4) + '|' + r1((ay - 66 * sc) / 4.4) + '|' + r3(tagO) + '|' + r1(20 + th);
        if (css !== tagCss) {
          tagCss = css;
          var pz = css.split('|');
          tag.style.left = pz[0] + '%';
          tag.style.top = pz[1] + '%';
          tag.style.opacity = pz[2];
          tag.style.transform = 'translate(-0.81em, -50%) rotate(' + pz[3] + 'deg)';
        }

        /* Paso 5 · el viaje sobre el Ecuador */
        var mo = tr(t4, 0, 0.2) * (1 - tr(t5, 0.05, 0.38));
        O(mapa, mo);
        if (mo > 0) {
          var zz = io(tr(t5, 0, 0.4));
          if (zz > 0) A(zoom, 'transform', 'translate(' + r1(R.fin[0]) + ' ' + r1(R.fin[1]) + ') scale(' + r3(1 + 2.2 * zz) + ') translate(' + r1(-R.fin[0]) + ' ' + r1(-R.fin[1]) + ')');
          else A(zoom, 'transform', 'translate(200 220) scale(' + r3(0.96 + 0.04 * eo(tr(t4, 0, 0.2))) + ') translate(-200 -220)');
          O(lugares, tr(t4, 0.1, 0.3));
          O(origen, tr(t4, 0.12, 0.28));
          var viaje = io(tr(t4, 0.24, 0.86));
          if (viaje !== ultimo) {
            ultimo = viaje;
            R.puntos.forEach(function (pp) { O(pp.el, pp.f <= viaje + 0.001 ? 1 : 0); });
          }
          O(ciudadG, tr(t4, 0.8, 0.92));
          if (R.pulso) {
            var pu = tr(t4, 0.84, 1);
            A(R.pulso, 'r', r1(5.5 + 12 * pu));
            O(R.pulso, pu > 0 ? 1 - pu : 0);
          }
        }

        /* Paso 6 · la puerta */
        var po = tr(t5, 0.12, 0.42);
        O(puerta, po);
        if (po > 0) A(puerta, 'transform', 'translate(200 384) scale(' + r3(0.94 + 0.06 * eo(po)) + ') translate(-200 -384)');
      }

      ruta(null, '', false);
      return { pintar: pintar, ruta: ruta, mensaje: mensaje, mecer: mecer, foto: cargarFoto };
    }

    /* Busca la ciudad en los lugares del mapa (alpaca.envios_mapa). */
    function punto(lugar, lista) {
      if (!lugar || lugar.tipo === 'galapagos') return null;
      var qn = limpio(lugar.nombre), mejor = null;
      (lista || []).forEach(function (l) { if (!mejor && limpio(l.c) === qn) mejor = l; });
      if (!mejor && qn.length > 3) (lista || []).forEach(function (l) { var nn = limpio(l.c); if (!mejor && (nn.indexOf(qn) >= 0 || qn.indexOf(nn) >= 0)) mejor = l; });
      if (mejor && mejor.x > 255) return en(mejor.x, mejor.y);
      if (lugar.tipo === 'quito') return QUITO.slice();
      return null;
    }

    function sePuedePegar(el) {
      for (var n = el.parentElement; n && n !== document.body; n = n.parentElement) {
        var cs = getComputedStyle(n);
        var ov = cs.overflowX + ' ' + cs.overflowY;
        /* Horizon desplaza la página dentro de .page-wrapper: ahí el escenario sí se queda fijo. */
        if (/(auto|scroll)/.test(cs.overflowY) && (n.classList.contains('page-wrapper') || n.scrollHeight > n.clientHeight + 1)) return !/(hidden|clip)/.test(cs.overflowX) || n.classList.contains('page-wrapper');
        if (/(hidden|auto|scroll)/.test(ov)) return false;
      }
      return true;
    }

    function iniciar(raiz) {
      if (raiz.getAttribute('data-alp-hf-listo')) return;
      raiz.setAttribute('data-alp-hf-listo', '1');
      var D = {};
      try { D = JSON.parse(raiz.querySelector('[data-alp-hf-datos]').textContent) || {}; } catch (e) { D = {}; }
      var tierra = raiz.querySelector('[data-alp-hf-tierra]');
      D.tierra = tierra ? tierra.getAttribute('d') : '';
      D.c1 = Number(D.c1) || 0; D.c2 = Number(D.c2) || 0;
      D.n1 = D.n1 || ''; D.n2 = D.n2 || '';
      var pasos = [].slice.call(raiz.querySelectorAll('.alp-hf__paso'));
      var base = (raiz.id || 'alp-hf') + '-';
      var escenas = [];
      var calma = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Textos del envío (paso 5), con el motor de la ficha. */
      var fechaEl = raiz.querySelector('[data-alp-hf-fecha]'), detEl = raiz.querySelector('[data-alp-hf-detalle]');
      var ejEl = raiz.querySelector('[data-alp-hf-ejemplo]'), ciudadBtn = raiz.querySelector('[data-alp-hf-ciudad]');
      function abridor() { return document.querySelector('[data-alp-envio] [data-alp-abrir]'); }
      function ciudad() {
        var Env = window.AlpacaEnvio, lugar = null;
        try { lugar = Env && Env.lugar ? Env.lugar() : null; } catch (e) { lugar = null; }
        var ejemplo = !lugar;
        if (!lugar) lugar = { tipo: 'resto', nombre: 'Guayaquil' };
        var pt = punto(lugar, D.lugares);
        escenas.forEach(function (es) { es.ruta(pt, pt ? lugar.nombre : '', ejemplo); });
        if (ejEl) { ejEl.hidden = !ejemplo; ejEl.textContent = ejemplo ? 'Guayaquil, como ejemplo.' : ''; }
        if (ciudadBtn) { ciudadBtn.hidden = !abridor(); ciudadBtn.textContent = ejemplo ? 'Ver para mi ciudad' : 'Cambiar ciudad'; }
        if (!Env || !Env.calcular) return;
        var r;
        try { r = Env.calcular(Env.feriados ? Env.feriados() : []); } catch (e2) { return; }
        var caja = document.querySelector('[data-alp-envio]'), ds = caja ? caja.dataset : {};
        var pq = ds.precioQuito || '$4.99', pr = ds.precioResto || '$5.50', pm = ds.precioMismoDia || '$8.50';
        var fecha, det;
        if (lugar.tipo === 'galapagos') {
          fecha = 'Tarda unos días más.';
          det = 'A ' + lugar.nombre + ' te confirmamos la fecha y el costo por WhatsApp.';
        } else if (lugar.tipo === 'quito') {
          fecha = r.texto;
          det = 'A ' + lugar.nombre + ', envío ' + pq + '. ' + (r.n && r.n.h < 21 ? '¿Lo necesitas hoy? Al pagar elige «Alpaca Flash» (' + pm + '), antes de las 9 p. m.' : 'Para el mismo día está «Alpaca Flash» (' + pm + '): se pide hasta las 9 p. m.');
        } else {
          fecha = r.texto;
          det = 'Sale de Quito y llega a ' + lugar.nombre + '. Envío ' + pr + '.' + (r.cuenta ? ' ' + r.cuenta : '');
        }
        /* Agotada: ni fecha ni costo (esos textos además quedan ocultos con data-alp-si-hay). */
        if (document.querySelector('[data-alp-estado-agotado]')) { fecha = ''; det = ''; }
        if (fechaEl) fechaEl.textContent = fecha;
        if (detEl) detEl.textContent = det;
      }
      if (ciudadBtn) ciudadBtn.addEventListener('click', function () { var a = abridor(); if (a) a.click(); });
      window.addEventListener('alpaca:ciudad', ciudad);
      /* Al elegir otra talla (agotada o no), blocks/alpaca-atajos avisa y se rehace el texto del envío. */
      document.addEventListener('alpaca:agotado', ciudad);
      /* El motor de envío de la ficha puede cargar después: al terminar la página se vuelve a calcular la fecha. */
      if (document.readyState !== 'complete') window.addEventListener('load', ciudad);

      /* El mensaje de la tarjeta, si lo escribió en la ficha. */
      function mensaje() {
        var ta = document.querySelector('.alp-regalo__mensaje'), cb = document.querySelector('[data-alp-regalo-si]');
        var t = ta && (!cb || cb.checked) ? ta.value : '';
        escenas.forEach(function (es) { es.mensaje(t); });
      }
      document.addEventListener('input', function (ev) { if (ev.target && ev.target.matches && ev.target.matches('.alp-regalo__mensaje')) mensaje(); });
      document.addEventListener('change', function (ev) { if (ev.target && ev.target.matches && ev.target.matches('[data-alp-regalo-si]')) mensaje(); });
      var btnMsj = raiz.querySelector('[data-alp-hf-mensaje]'), casilla = document.querySelector('[data-alp-regalo-si]');
      if (btnMsj && casilla) {
        btnMsj.hidden = false;
        btnMsj.addEventListener('click', function () {
          if (!casilla.checked) casilla.click();
          var ta = document.querySelector('.alp-regalo__mensaje') || casilla;
          ta.scrollIntoView({ block: 'center', behavior: calma ? 'auto' : 'smooth' });
          setTimeout(function () { try { ta.focus({ preventScroll: true }); } catch (e) {} }, 450);
        });
      }

      /* «Agregar al carrito»: si la ficha tiene otra variante elegida, se suma esa. */
      var sumar = raiz.querySelector('[data-alp-sumar]');
      if (sumar) sumar.addEventListener('click', function () {
        var inp = document.querySelector('.product-details form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (inp && inp.value && !sumar.hasAttribute('data-sumado')) sumar.setAttribute('data-alp-sumar', inp.value);
      }, true);

      function despues() { ciudad(); mensaje(); }

      /* «Saltar la historia»: baja hasta el final de la sección y deja el foco ahí.
         En compu Horizon desplaza la página dentro de .page-wrapper, no en la ventana (igual que el foco del teclado de abajo). */
      var saltar = raiz.querySelector('[data-alp-hf-saltar]'), finEl = raiz.querySelector('[data-alp-hf-fin]');
      if (saltar && finEl) saltar.addEventListener('click', function (ev) {
        ev.preventDefault();
        var sc = document.querySelector('.page-wrapper');
        var conPw = sc && sc.scrollHeight > sc.clientHeight + 1;
        var dy = finEl.getBoundingClientRect().top - 96;
        /* Un salto directo (no desplazamiento suave): saltar no es volver a ver la historia a toda velocidad. */
        var y = Math.round((conPw ? sc.scrollTop : window.pageYOffset) + dy);
        try {
          if (conPw) sc.scrollTo({ top: y, behavior: 'instant' }); else window.scrollTo({ top: y, behavior: 'instant' });
        } catch (e) {
          if (conPw) sc.scrollTop = y; else window.scrollTo(0, y);
        }
        try { finEl.focus({ preventScroll: true }); } catch (e) { finEl.focus(); }
      });

      /* Movimiento reducido (o una página donde el escenario no puede quedarse fijo): tarjetas con su dibujo final. */
      if (calma || !('IntersectionObserver' in window) || !sePuedePegar(raiz)) {
        raiz.classList.add('alp-hf--quieto');
        pasos.forEach(function (li, i) {
          var fig = document.createElement('div');
          fig.className = 'alp-hf__fig';
          fig.setAttribute('aria-hidden', 'true');
          li.insertBefore(fig, li.firstChild);
          var es = Escena(fig, D, base + 'q' + i + '-');
          es.foto();
          escenas.push({ es: es, i: i });
        });
        escenas = escenas.map(function (o) {
          var es = o.es, i = o.i, fin = (INI[i] + PESOS[i] * FINES[i]) / SUMA;
          return {
            ruta: function (a, b, c) { es.ruta(a, b, c); es.pintar(fin); },
            mensaje: function (t) { es.mensaje(t); es.pintar(fin); }
          };
        });
        despues();
        return;
      }

      /* Con movimiento: el escenario se queda fijo y el dibujo avanza con lo que se baja. */
      raiz.classList.add('alp-hf--vivo');
      var pista = raiz.querySelector('[data-alp-hf-pista]'), esc = raiz.querySelector('[data-alp-hf-escenario]');
      var lienzo = raiz.querySelector('[data-alp-hf-lienzo]'), hilo = raiz.querySelector('[data-alp-hf-hilo]');
      var nudos = hilo ? [].slice.call(hilo.querySelectorAll('b')) : [];
      var E = Escena(lienzo, D, base + 'v-');
      escenas.push(E);
      var alto = 0, ancho = 0, recorrido = 1, tope = 0;

      function medir() {
        var w = window.innerWidth, h = document.documentElement.clientHeight;
        /* En el iPhone la altura cambia al esconderse la barra de Safari: solo se recalcula si cambia de verdad. */
        if (!alto || w !== ancho || Math.abs(h - alto) > 140) { ancho = w; alto = h; }
        /* ~30 % más corto que al principio (0,6 → 0,42 del alto por cada unidad de peso). */
        recorrido = Math.max(1, Math.round(SUMA * alto * 0.42));
        pista.style.height = (esc.offsetHeight + recorrido) + 'px';
        tope = parseFloat(getComputedStyle(esc).top) || 0;
        pedir();
      }
      function progreso() { return cl((tope - pista.getBoundingClientRect().top) / recorrido, 0, 1); }

      var activo = -1;
      function marcar(p) {
        var x = p * SUMA, i = 0;
        while (i < 5 && x >= INI[i + 1]) i++;
        if (i !== activo) {
          activo = i;
          pasos.forEach(function (li, j) {
            li.classList.toggle('alp-hf--activo', j === i);
            li.classList.toggle('alp-hf--antes', j < i);
          });
          nudos.forEach(function (b, j) {
            b.classList.toggle('alp-hf--hecho', j < i);
            b.classList.toggle('alp-hf--ahora', j === i);
          });
        }
        if (hilo) hilo.style.setProperty('--hf-avance', r3(Math.min(1, (i + cl((x - INI[i]) / PESOS[i], 0, 1)) / 5)));
      }

      var actual = -1, corre = false, tPrev = 0;
      function cuadro(ts) {
        var dt = tPrev ? Math.min((ts - tPrev) / 1000, 0.05) : 1 / 60;
        tPrev = ts;
        var meta = progreso(), antes = actual < 0 ? meta : actual;
        actual = antes + (meta - antes) * Math.min(1, dt * 12);
        if (Math.abs(meta - actual) < 0.0003) actual = meta;
        var mueve = E.mecer(dt > 0 ? (actual - antes) / dt : 0, dt);
        E.pintar(actual);
        marcar(actual);
        if (actual !== meta || mueve) requestAnimationFrame(cuadro);
        else { corre = false; tPrev = 0; }
      }
      function pedir() { if (!corre) { corre = true; requestAnimationFrame(cuadro); } }

      /* Escucha el desplazamiento de la ventana y de .page-wrapper (en captura, porque no burbujea). */
      document.addEventListener('scroll', pedir, { passive: true, capture: true });
      window.addEventListener('resize', function () { requestAnimationFrame(medir); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { medir(); }).observe(esc);
      /* La foto se pide recién cuando la historia está cerca. */
      new IntersectionObserver(function (es, obs) {
        if (es.some(function (e) { return e.isIntersecting; })) { E.foto(); obs.disconnect(); }
      }, { rootMargin: '900px 0px' }).observe(pista);

      /* Con teclado: al llegar a un botón de un paso, la página baja hasta ese paso. */
      raiz.addEventListener('focusin', function (ev) {
        var li = ev.target && ev.target.closest ? ev.target.closest('.alp-hf__paso') : null;
        var i = pasos.indexOf(li);
        if (i < 0 || i === activo) return;
        var sc = document.querySelector('.page-wrapper');
        var conPw = sc && sc.scrollHeight > sc.clientHeight + 1;
        var base0 = conPw ? sc.scrollTop : window.pageYOffset;
        var y = base0 + pista.getBoundingClientRect().top - tope + ((INI[i] + PESOS[i] * 0.6) / SUMA) * recorrido;
        if (conPw) sc.scrollTop = Math.round(y); else window.scrollTo(0, Math.round(y));
      });

      medir();
      despues();
      E.pintar(progreso());
      marcar(progreso());
    }

    function todo(raiz) {
      (raiz || document).querySelectorAll('[data-alp-hf]').forEach(iniciar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { todo(); });
    else todo();
    document.addEventListener('shopify:section:load', function (e) { todo(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-opinion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NOMBRES = ['', 'Mala', 'Regular', 'Buena', 'Muy buena', 'Excelente'];
    var ERRORES = {
      enlace: 'Este enlace no es válido. Escríbenos por WhatsApp al 098 7878 444 y te ayudamos.',
      pedido: 'No encontramos este pedido. Escríbenos por WhatsApp al 098 7878 444.',
      producto: 'Elige la prenda sobre la que quieres opinar.',
      estrellas: 'Elige cuántas estrellas le das.',
      texto: 'Escribe tu opinión con tus palabras.',
      permiso: 'Para publicarla necesitamos que marques la casilla de permiso.',
      repetida: 'Ya nos dejaste tu opinión sobre esta prenda. ¡Gracias!',
      pendiente: 'Tu pedido todavía no figura como pagado. Escríbenos por WhatsApp al 098 7878 444 y lo revisamos.'
    };

    function iniciar() {
      var raiz = document.querySelector('[data-alp-opina]');
      if (!raiz || raiz.dataset.listo) return;
      raiz.dataset.listo = '1';
      var api = raiz.getAttribute('data-api');
      var u = new URLSearchParams(window.ALPACA_QS || location.search);
      var p = u.get('p') || '', t = u.get('t') || '';
      /* La firma no se queda en la dirección (la leerían píxeles y estadísticas): se guarda en la pestaña. */
      try {
        if (p && t) {
          sessionStorage.setItem('alpaca_opina', JSON.stringify({ p: p, t: t }));
          history.replaceState(null, '', location.pathname);
        } else {
          var g = JSON.parse(sessionStorage.getItem('alpaca_opina') || 'null');
          if (g) { p = g.p; t = g.t; }
        }
      } catch (e) {}
      function visible(k) { var g = raiz.querySelector('[data-calce="' + k + '"]'); return g && !g.hidden; }

      /* Foto opcional: se achica en el teléfono (máximo 1600 px, JPG) antes de enviarla. */
      var fotoData = '';
      var fotoIn = raiz.querySelector('[data-foto-input]'), fotoVista = raiz.querySelector('[data-foto-vista]');
      var fotoTxt = raiz.querySelector('[data-foto-texto]'), fotoQuitar = raiz.querySelector('[data-foto-quitar]');
      function quitarFoto() {
        fotoData = ''; fotoIn.value = ''; fotoVista.hidden = true; fotoVista.removeAttribute('src');
        fotoTxt.textContent = 'Elegir foto'; fotoQuitar.hidden = true;
      }
      fotoQuitar.addEventListener('click', quitarFoto);
      fotoIn.addEventListener('change', function () {
        var archivo = fotoIn.files && fotoIn.files[0];
        if (!archivo) return;
        fotoTxt.textContent = 'Preparando la foto…';
        var url = URL.createObjectURL(archivo), img = new Image();
        img.onload = function () {
          var max = 1600, w = img.naturalWidth, h = img.naturalHeight, k = Math.min(1, max / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.round(w * k); c.height = Math.round(h * k);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          fotoData = c.toDataURL('image/jpeg', 0.82);
          URL.revokeObjectURL(url);
          fotoVista.src = fotoData; fotoVista.hidden = false;
          fotoTxt.textContent = 'Cambiar foto'; fotoQuitar.hidden = false;
        };
        img.onerror = function () { URL.revokeObjectURL(url); quitarFoto(); error.textContent = 'No pudimos abrir esa foto. Prueba con otra.'; };
        img.src = url;
      });
      var estado = raiz.querySelector('[data-estado]');
      var form = raiz.querySelector('[data-form]');
      var error = raiz.querySelector('[data-error]');
      var gracias = raiz.querySelector('[data-gracias]');
      var productos = [];

      if (!/^\d{6,20}$/.test(p) || !/^[a-f0-9]{20}$/.test(t)) { estado.textContent = ERRORES.enlace; return; }

      function pintarProductos() {
        var caja = raiz.querySelector('[data-productos]');
        caja.innerHTML = '';
        var pendientes = productos.filter(function (x) { return !x.hecho; });
        pendientes.forEach(function (x, i) {
          var l = document.createElement('label');
          l.className = 'alp-opina__producto';
          var r = document.createElement('input');
          r.type = 'radio'; r.name = 'producto'; r.value = x.id; r.dataset.titulo = x.titulo;
          if (i === 0) r.checked = true;
          l.appendChild(r);
          if (x.imagen) { var im = document.createElement('img'); im.src = x.imagen + (x.imagen.indexOf('?') < 0 ? '?' : '&') + 'width=120'; im.alt = ''; im.width = 52; im.height = 65; l.appendChild(im); }
          var s = document.createElement('span'); s.textContent = x.titulo; l.appendChild(s);
          caja.appendChild(l);
        });
        raiz.querySelector('[data-productos-caja]').hidden = pendientes.length < 2;
        var sobre = raiz.querySelector('[data-sobre]');
        sobre.hidden = pendientes.length !== 1;
        sobre.textContent = pendientes.length === 1 ? 'Opinas sobre: ' + pendientes[0].titulo : '';
        revisarCalce();
        return pendientes.length;
      }

      function revisarCalce() {
        var sel = form.querySelector('input[name="producto"]:checked');
        var tit = sel ? (sel.dataset.titulo || '').toLowerCase() : '';
        raiz.querySelector('[data-calce="largo"]').hidden = !/\b(poncho|chal)\b/.test(tit);
        raiz.querySelector('[data-calce="talla"]').hidden = !/\b(abrigo|chaqueta)\b|pac 01/.test(tit);
      }

      fetch(api + '?p=' + encodeURIComponent(p) + '&t=' + encodeURIComponent(t))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || !d.ok) { estado.textContent = ERRORES[d && d.error] || ERRORES.enlace; return; }
          productos = d.productos || [];
          if (!pintarProductos()) { estado.textContent = ERRORES.repetida; return; }
          estado.textContent = '';
          form.hidden = false;
        })
        .catch(function () { estado.textContent = 'No pudimos cargar tu pedido. Prueba de nuevo en un rato.'; });

      form.addEventListener('change', function (e) {
        if (e.target.name === 'estrellas') {
          var v = Number(e.target.value);
          form.querySelectorAll('[data-estrellas] label').forEach(function (l, i) { l.classList.toggle('is-on', i < v); });
          raiz.querySelector('[data-estrellas-txt]').textContent = NOMBRES[v];
        }
        if (e.target.name === 'producto') revisarCalce();
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        error.textContent = '';
        var f = new FormData(form);
        var cuerpo = {
          p: p, t: t,
          producto: f.get('producto') || '',
          estrellas: f.get('estrellas') || '',
          texto: (f.get('texto') || '').trim(),
          nombre: (f.get('nombre') || '').trim(),
          ciudad: (f.get('ciudad') || '').trim(),
          estatura: visible('largo') ? (f.get('estatura') || '') : '',
          largo: visible('largo') ? (f.get('largo') || '') : '',
          talla: visible('talla') ? (f.get('talla') || '') : '',
          calce: visible('talla') ? (f.get('calce') || '') : '',
          regalo: !!f.get('regalo'),
          permiso: !!f.get('permiso'),
          foto: fotoData || ''
        };
        if (!cuerpo.producto) { error.textContent = ERRORES.producto; return; }
        if (!cuerpo.estrellas) { error.textContent = ERRORES.estrellas; return; }
        if (cuerpo.texto.length < 3) { error.textContent = ERRORES.texto; return; }
        var boton = form.querySelector('[type="submit"]');
        boton.setAttribute('aria-busy', 'true'); boton.disabled = true;
        fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(cuerpo) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            boton.removeAttribute('aria-busy'); boton.disabled = false;
            if (!d || !d.ok) { error.textContent = ERRORES[d && d.error] || 'No pudimos guardar tu opinión. Prueba de nuevo.'; return; }
            productos.forEach(function (x) { if (String(x.id) === String(cuerpo.producto)) x.hecho = true; });
            form.hidden = true;
            gracias.hidden = false;
            gracias.querySelector('[data-otra]').hidden = !productos.some(function (x) { return !x.hecho; });
            gracias.focus();
          })
          .catch(function () { boton.removeAttribute('aria-busy'); boton.disabled = false; error.textContent = 'No pudimos guardar tu opinión. Revisa tu conexión y prueba de nuevo.'; });
      });

      gracias.querySelector('[data-otra]').addEventListener('click', function () {
        form.reset();
        quitarFoto();
        form.querySelectorAll('[data-estrellas] label').forEach(function (l) { l.classList.remove('is-on'); });
        raiz.querySelector('[data-estrellas-txt]').textContent = '';
        pintarProductos();
        gracias.hidden = true;
        form.hidden = false;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
    else iniciar();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-portada-comprar"] && !Shopify.designMode) return;
  try {
    
  /* Alpaca · «¿Cuándo te llega?»: dibuja la fecha y el costo con el motor de envío de la ficha (window.AlpacaEnvio). */
  (function () {
    'use strict';

    function poner(el, txt) {
      if (!el) return;
      if (el.textContent !== txt) el.textContent = txt;
      el.hidden = !txt;
    }

    function armar(sec) {
      if (sec.__alpCl) return;
      sec.__alpCl = true;
      var caja = sec.querySelector('[data-alp-envio]');
      var q = function (s) { return sec.querySelector(s); };
      var fila = q('[data-alp-cl-ciudad]'), lugarEl = q('[data-alp-cl-lugar]'), cambiar = q('[data-alp-cl-cambiar]');
      var fechaEl = q('[data-alp-cl-fecha]'), cuentaEl = q('[data-alp-cl-cuenta]'), costoEl = q('[data-alp-cl-costo]');
      var flashEl = q('[data-alp-cl-flash]'), quitoEl = q('[data-alp-quito]');

      function pintar() {
        var E = window.AlpacaEnvio;
        if (!E || !E.calcular || !caja) return false;
        var r = E.calcular(E.feriados ? E.feriados() : []);
        var lugar = E.lugar ? E.lugar() : null;
        var tipo = lugar ? lugar.tipo : '';
        var pq = caja.getAttribute('data-precio-quito') || '$4.99';
        var pr = caja.getAttribute('data-precio-resto') || '$5.50';
        var pm = caja.getAttribute('data-precio-mismo-dia') || '$8.50';
        sec.classList.add('alp-cl--vivo');
        if (fila) fila.hidden = false;
        if (lugarEl) lugarEl.textContent = lugar ? lugar.nombre : '';
        if (cambiar) cambiar.textContent = lugar ? 'Cambiar' : 'Elige tu ciudad';
        if (tipo === 'galapagos') {
          if (fechaEl) fechaEl.textContent = 'Tarda unos días más.';
          poner(costoEl, 'Te confirmamos fecha y costo por WhatsApp.');
          poner(cuentaEl, '');
          poner(flashEl, '');
        } else {
          if (fechaEl && r && r.texto && fechaEl.textContent !== r.texto) fechaEl.textContent = r.texto;
          poner(costoEl, 'Envío ' + (tipo === 'quito' ? pq : pr) + '.');
          poner(cuentaEl, (r && r.cuenta) || '');
          var flash = '';
          var sinF = !!(window.AlpacaEnvio && window.AlpacaEnvio.sinFlash && window.AlpacaEnvio.sinFlash(r && r.n));
          if (tipo === 'quito' && r && r.n && !sinF) {
            flash = r.n.h < 21
              ? '¿Lo necesitas hoy? Pídelo antes de las 9 p. m. y te llega hoy mismo, por ' + pm + '.'
              : 'También puedes pedirlo para el mismo día (' + pm + '): se pide hasta las 9 p. m.';
          }
          poner(flashEl, flash);
        }
        /* Modo viaje sin reemplazo: esos días no se ofrece Flash (ni la letra chica de Quito). */
        if (quitoEl) quitoEl.hidden = tipo === 'quito' || tipo === 'galapagos' || !!(window.AlpacaEnvio && window.AlpacaEnvio.sinFlash && window.AlpacaEnvio.sinFlash());
        return true;
      }

      /* El motor llega con los guiones de los bloques: si todavía no está, se espera un poco */
      if (!pintar()) {
        var intentos = 0;
        var t = setInterval(function () { if (pintar() || ++intentos > 40) clearInterval(t); }, 250);
        window.addEventListener('load', pintar);
      }
      window.addEventListener('alpaca:ciudad', pintar);
      setInterval(function () { if (!document.hidden && sec.isConnected) pintar(); }, 60000);

      if (cambiar) cambiar.addEventListener('click', function () {
        var d = caja && caja.querySelector('dialog');
        if (d && d.showModal && !d.open) d.showModal();
      });

      /* El subrayado se pinta una vez, al aparecer */
      var fecha = q('.alp-cl-fecha');
      if (fecha && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            sec.classList.add('alp-cl--pinta');
          });
        }, { rootMargin: '0px 0px -15% 0px' });
        io.observe(fecha);
      } else {
        sec.classList.add('alp-cl--pinta');
      }
    }

    function iniciar(raiz) {
      if (!raiz || !raiz.querySelectorAll) return;
      if (raiz.matches && raiz.matches('[data-alp-cl]')) armar(raiz);
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-alp-cl]'), armar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-portada-regalo"] && !Shopify.designMode) return;
  try {
    
  /* Alpaca · tarjeta de regalo que se mece: péndulo amortiguado al aparecer; en la compu, otra vez al pasar el mouse. */
  (function () {
    'use strict';
    var reducido = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    function armar(sec) {
      if (sec.__alpRg) return;
      sec.__alpRg = true;
      var c = sec.querySelector('[data-alp-rg-colgante]');
      var tarjeta = sec.querySelector('.alp-rg-tarjeta');
      if (!c || !tarjeta) return;
      var reposo = (parseFloat(c.getAttribute('data-giro')) || 0) * Math.PI / 180;
      var th = 0, w = 0, corriendo = false, tAnt = 0, lado = 1;

      function paso(t) {
        var dt = Math.min(0.034, Math.max(0.001, (t - tAnt) / 1000));
        tAnt = t;
        var a = -8.5 * Math.sin(th) - 1.3 * w;
        w += a * dt;
        th += w * dt;
        if (Math.abs(th) < 0.001 && Math.abs(w) < 0.003) { th = 0; w = 0; corriendo = false; }
        c.style.transform = 'rotate(' + (reposo + th).toFixed(4) + 'rad)';
        if (corriendo) requestAnimationFrame(paso);
      }
      function empujar(v) {
        if (reducido.matches) return;
        w += v;
        if (!corriendo) { corriendo = true; tAnt = performance.now(); requestAnimationFrame(paso); }
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.disconnect();
            setTimeout(function () { empujar(1.15); }, 180);
          });
        }, { rootMargin: '0px 0px -22% 0px' });
        io.observe(c.parentNode || c);
      }

      tarjeta.addEventListener('pointerenter', function (ev) {
        if (ev.pointerType !== 'mouse') return;
        if (Math.abs(w) > 0.3 || Math.abs(th) > 0.08) return;
        lado = -lado;
        empujar(0.75 * lado);
      });
    }

    function iniciar(raiz) {
      if (!raiz || !raiz.querySelectorAll) return;
      if (raiz.matches && raiz.matches('[data-alp-rg]')) armar(raiz);
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-alp-rg]'), armar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpaca-portada-tendedero"] && !Shopify.designMode) return;
  try {
    
  /* Alpaca · tendedero de preguntas: el hilo, el vaivén de cada etiqueta y el giro al tocarla. */
  (function () {
    'use strict';
    var reducido = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var ALTO = 10, CAIDA = 36; /* el hilo: altura en los extremos y cuánto cae en el centro (px) */
    var TOPE = 0.32; /* ángulo máximo (rad): se mecen, no dan vueltas */

    function limitar(v, a) { return v > a ? a : v < -a ? -a : v; }

    function armar(sec) {
      if (sec.__alpTd) return;
      sec.__alpTd = true;
      var pista = sec.querySelector('[data-alp-td-pista]');
      var corredor = sec.querySelector('[data-alp-td-corredor]');
      var lis = Array.prototype.slice.call(sec.querySelectorAll('[data-alp-td-item]'));
      if (!pista || !lis.length) return;
      sec.classList.add('alp-td--vivo');

      var et = lis.map(function (li, i) {
        var e = {
          li: li,
          col: li.querySelector('.alp-td-colgante'),
          btn: li.querySelector('.alp-td-frente'),
          dorso: li.querySelector('.alp-td-dorso'),
          reposo: (parseFloat(li.getAttribute('data-giro')) || 0) * Math.PI / 180,
          th: 0,
          w: 0,
          k: 13.5 + ((i * 7) % 5) * 0.9, /* cada una con su propio ritmo, como etiquetas de distinto peso */
          g: 0.82 + ((i * 3) % 4) * 0.09
        };
        cerrarCara(e);
        e.btn.addEventListener('click', function () { alternar(e); });
        e.dorso.addEventListener('click', function (ev) {
          if (ev.target.closest && ev.target.closest('a')) return;
          alternar(e, false);
          try { e.btn.focus({ preventScroll: true }); } catch (er) { e.btn.focus(); }
        });
        return e;
      });

      function cerrarCara(e) {
        e.li.removeAttribute('data-abierta');
        e.btn.setAttribute('aria-expanded', 'false');
        e.dorso.inert = true;
        e.dorso.setAttribute('inert', '');
      }
      function alternar(e, abrir) {
        if (abrir === undefined) abrir = !e.li.hasAttribute('data-abierta');
        if (abrir) {
          et.forEach(function (o) { if (o !== e && o.li.hasAttribute('data-abierta')) cerrarCara(o); });
          e.li.setAttribute('data-abierta', '');
          e.btn.setAttribute('aria-expanded', 'true');
          e.dorso.inert = false;
          e.dorso.removeAttribute('inert');
        } else {
          cerrarCara(e);
        }
        /* El toque también la mueve un poquito en su pinza */
        e.w += (e.reposo >= 0 ? -0.55 : 0.55);
        despertar();
      }
      sec.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape') return;
        et.forEach(function (e) {
          if (!e.li.hasAttribute('data-abierta')) return;
          cerrarCara(e);
          e.btn.focus();
        });
      });

      /* Dónde cae cada pinza sobre el hilo (la misma curva que dibuja el SVG) */
      function medir() {
        var W = pista.clientWidth;
        if (!W) return;
        lis.forEach(function (li) {
          var u = 2 * (li.offsetLeft + li.offsetWidth / 2) / W - 1;
          li.style.setProperty('--y', (ALTO + CAIDA * (1 - u * u)).toFixed(1) + 'px');
        });
      }
      medir();
      var espera = 0;
      window.addEventListener('resize', function () { cancelAnimationFrame(espera); espera = requestAnimationFrame(medir); });

      /* El péndulo: aceleración = −k·sen(θ) − c·ω, paso a paso (Euler semi-implícito) */
      var corriendo = false, tAnt = 0, dy = 0, dx = 0;
      function pintar(e) { e.col.style.transform = 'rotate(' + (e.reposo + e.th).toFixed(4) + 'rad)'; }
      function paso(t) {
        var dt = Math.min(0.034, Math.max(0.001, (t - tAnt) / 1000));
        tAnt = t;
        var vy = limitar(dy, 90), vx = limitar(dx, 90);
        dy = 0; dx = 0;
        var quietas = true;
        et.forEach(function (e) {
          if (vy) e.w += vy * 0.0042 * e.g;  /* bajar rápido = ráfaga: se balancean más */
          if (vx) e.w -= vx * 0.0036;       /* deslizar el hilo: se quedan atrás un instante */
          var a = -e.k * Math.sin(e.th) - 1.2 * e.w;
          e.w = limitar(e.w + a * dt, 4);
          e.th = limitar(e.th + e.w * dt, TOPE);
          if (Math.abs(e.th) < 0.0012 && Math.abs(e.w) < 0.004) { e.th = 0; e.w = 0; } else { quietas = false; }
          pintar(e);
        });
        if (quietas) { corriendo = false; return; }
        requestAnimationFrame(paso);
      }
      function despertar() {
        if (corriendo || reducido.matches) return;
        corriendo = true;
        tAnt = performance.now();
        requestAnimationFrame(paso);
      }

      /* «desliza»: en el celular, si hay etiquetas fuera de la pantalla, una nota a mano lo dice una sola vez; se va al
         primer deslizamiento y ya no vuelve (se recuerda en el teléfono). */
      var desliza = sec.querySelector('[data-alp-td-desliza]'), deslizaFuera = false;
      function yaDeslizo() { try { return localStorage.getItem('alpaca_td_deslizo') === '1'; } catch (er) { return false; } }
      function mostrarDesliza() {
        if (!desliza || deslizaFuera || !corredor || yaDeslizo()) return;
        if (corredor.scrollWidth - corredor.clientWidth < 24 || corredor.scrollLeft > 12) return;
        desliza.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { desliza.classList.add('alp-td-desliza--va'); }); });
        /* Si los cuadros están frenados, igual se ve. */
        setTimeout(function () { if (!deslizaFuera) desliza.classList.add('alp-td-desliza--va'); }, 400);
      }
      function quitarDesliza() {
        if (!desliza || deslizaFuera || !corredor || corredor.scrollLeft < 12) return;
        deslizaFuera = true;
        try { localStorage.setItem('alpaca_td_deslizo', '1'); } catch (er) {}
        desliza.classList.add('alp-td-desliza--se-va');
        setTimeout(function () { desliza.hidden = true; }, 350);
      }

      /* Solo se mueve si se ve */
      var visible = false, primera = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            visible = en.isIntersecting;
            if (visible && primera) {
              primera = false;
              mostrarDesliza();
              if (reducido.matches) return;
              /* Al aparecer: una ola suave recorre el hilo, de izquierda a derecha, una sola vez */
              et.forEach(function (e, i) { setTimeout(function () { e.w += 0.8 * e.g; despertar(); }, 160 + i * 120); });
            }
          });
        }, { rootMargin: '0px 0px -18% 0px' }).observe(sec);
      } else {
        visible = true;
      }

      /* Velocidad del desplazamiento: de la página (Horizon puede desplazar .page-wrapper) y del hilo en el celular */
      var ult = typeof WeakMap === 'function' ? new WeakMap() : null;
      var xAnt = corredor ? corredor.scrollLeft : 0;
      function alDesplazar(ev) {
        if (!sec.isConnected) { document.removeEventListener('scroll', alDesplazar, true); return; }
        var t = ev.target;
        if (t === corredor) {
          quitarDesliza();
          var x = corredor.scrollLeft;
          dx += x - xAnt;
          xAnt = x;
          if (visible) despertar();
          return;
        }
        if (!ult) return;
        var el = (t === document || t === window || !t.nodeType || t.nodeType === 9) ? (document.scrollingElement || document.documentElement) : t;
        var y = el.scrollTop, a = ult.get(el);
        ult.set(el, y);
        if (a === undefined || !visible) return;
        dy += y - a;
        despertar();
      }
      document.addEventListener('scroll', alDesplazar, { passive: true, capture: true });

      /* El mouse las empuja al pasar (más fuerte cuanto más abajo las toca) */
      pista.addEventListener('pointermove', function (ev) {
        if (ev.pointerType !== 'mouse' || reducido.matches) return;
        var vx = limitar(ev.movementX || 0, 40);
        if (!vx) return;
        et.forEach(function (e) {
          var r = e.col.getBoundingClientRect();
          if (ev.clientX < r.left - 4 || ev.clientX > r.right + 4 || ev.clientY < r.top || ev.clientY > r.bottom) return;
          var palanca = Math.max(0.25, Math.min(1, (ev.clientY - r.top) / r.height));
          e.w -= vx * 0.018 * palanca;
          despertar();
        });
      });
    }

    function iniciar(raiz) {
      if (!raiz || !raiz.querySelectorAll) return;
      if (raiz.matches && raiz.matches('[data-alp-td]')) armar(raiz);
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-alp-td]'), armar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    else iniciar(document);
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
